import { Divider, FormControl, FormControlLabel, FormGroup, Switch, Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import Theme from '../../Themes/main.theme';
import { Box } from '@mui/system';

interface ISwitchOption {
  label: string;
  info: string;
  name: string;
  checked: boolean;
  radioValue?: any
}
interface ISwitchButtonsList {
  options: ISwitchOption[] | { [x: string]: any }[],
  children?: JSX.Element | boolean | undefined,
  handleSwitchChange?: (e: any) => void,
  checked?: boolean,
  internal?: boolean,
  disabled?: boolean,
  line?: boolean
}

function SwitchButtonsList(props: ISwitchButtonsList) {
  const {options = [], handleSwitchChange, disabled, line = true} = props;

  return (
    <> 
      <FormControl component='fieldset' variant='standard'>
        {options.map((option, index) => {
          return (
            <Box key={index} width='100%'> 
              {Object.values(option).flat().map(x => {
                if (!x) return;
                const {
                  info,
                  name,
                  label,
                  checked,
                } = x;
         
                return (
                  <FormGroup key={name} aria-label='position' >
                    <Box display='flex' >
                      <Tooltip 
                        PopperProps={{
                          disablePortal: true
                        }} title={<Typography variant='subtitle2'>{info}
                        </Typography>}
                        placement='left-start'>
                        <InfoIcon sx={{my: 1.5, color: Theme?.iconColor?.main, fontSize: '24px'}}/>
                      </Tooltip>
                      <FormControlLabel
                        value='start'
                        name={name}
                        style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}
                        control={<Switch 
                          checked={checked}
                          onChange={handleSwitchChange} color='primary' />}
                        label={label}
                        disabled={disabled}
                        labelPlacement='start'
                      /> 
                    </Box>
                  </FormGroup>
                );
              })}
              {line && <Divider sx={{mt: 1, mb: 1 }}/>}
            </Box>
          );         
        })
        }
      </FormControl>
    </>
  );
}

export default SwitchButtonsList;